import type { OwnerListQuery } from '@chukua/common';
import type { TableColumnsType } from 'antd';
import { Link } from 'react-router';
import type { ListQueryControls } from '../../lib/use-list-query';
import type { OwnerListItem } from './owners.api';
import { PAYOUT_METHOD_LABELS } from './payout-method-labels';
import { fleetRecordPath } from '../fleet/fleet-tabs';

interface BuildOwnerColumnsArgs {
  list: Pick<ListQueryControls<OwnerListQuery>, 'sortOrderFor'>;
}

/** Sorting runs on the server: each column's `key` is its `sort` field in `ownerListQuerySchema`. */
export function buildOwnerColumns({ list }: BuildOwnerColumnsArgs): TableColumnsType<OwnerListItem> {
  return [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      sortOrder: list.sortOrderFor('name'),
      render: (name: string, owner) => (
        <Link className="font-medium text-link hover:underline" to={fleetRecordPath('owners', owner.id)}>
          {name}
        </Link>
      ),
    },
    {
      title: 'Payout method',
      dataIndex: 'payoutMethod',
      key: 'payoutMethod',
      render: (payoutMethod: string) => PAYOUT_METHOD_LABELS[payoutMethod as keyof typeof PAYOUT_METHOD_LABELS] ?? payoutMethod,
    },
    {
      title: '',
      key: 'actions',
      render: (_, owner) => (
        <Link className="text-sm font-medium text-link hover:underline" to={fleetRecordPath('owners', owner.id)}>
          View
        </Link>
      ),
    },
  ];
}
